__turbopack_context__.v({
  "buttonContent": "namePortfolioForm-module-scss-module__vARWMG__buttonContent",
  "buttonFetching": "namePortfolioForm-module-scss-module__vARWMG__buttonFetching",
  "buttonWrapper": "namePortfolioForm-module-scss-module__vARWMG__buttonWrapper",
  "continueButton": "namePortfolioForm-module-scss-module__vARWMG__continueButton",
  "description": "namePortfolioForm-module-scss-module__vARWMG__description",
  "emptyIcon": "namePortfolioForm-module-scss-module__vARWMG__emptyIcon",
  "explanationUsage": "namePortfolioForm-module-scss-module__vARWMG__explanationUsage",
  "form": "namePortfolioForm-module-scss-module__vARWMG__form",
  "formArea": "namePortfolioForm-module-scss-module__vARWMG__formArea",
  "formWrapper": "namePortfolioForm-module-scss-module__vARWMG__formWrapper",
  "title": "namePortfolioForm-module-scss-module__vARWMG__title",
});
